import { Container, FormControl, MenuItem, Select, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Events } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  container: {
    "& h5": {
      marginTop: 15,
      marginBottom: 25,
      fontSize: 17,
      fontWeight: "bold",
      color: "#000000",
    },
    "& .MuiTypography-body1": {
      marginBottom: 20,
      fontSize: 16,
      fontWeight: 500,
      color: "#525252",
    },
    "& .MuiInputBase-root": {
      height: 43,
      fontSize: 14,
      color: "#4A4A4A",
      textTransform: "capitalize",
      marginBottom: 20,
    },
    "& textarea": {
      padding: 15,
      height: 83,
      width: "100%",
      fontSize: 14,
      color: "#4A4A4A",
      backgroundColor: "transparent",
    },
  },
}));

type SessionCancelProps = {
  event: Events.IAgenda;
  cancelSession: (params?: { reason: string; notes: string }) => void;
  children?: any;
};

const SessionCancel: React.FC<SessionCancelProps> = ({ event, cancelSession }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const generateOptions: () => JSX.Element[] = () => {
    let options: JSX.Element[] = [];
    const reasons: string[] = ["CLIENT_SICK", "NO_SHOW", "PT_NOT_AVAILABLE", "OTHER"];
    options = reasons.map((el, i) => (
      <MenuItem key={i} value={el} style={{ textTransform: "none" }}>
        {t(`${el.replace(/_/g, " ").replace("CLIENT", "CLIENT WAS").toLowerCase()}`)}
      </MenuItem>
    ));
    return options;
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const notes = formData.get("notes");
    const reason = formData.get("reason");
    if (typeof notes === "string" && typeof reason === "string")
      return cancelSession({ reason, notes });
    else return cancelSession();
  };
  return (
    <Container className={classes.container}>
      <Typography variant="h5">{/* {t("Cancelled")} {generateTimeToSession()} */}</Typography>
      <form id="session-cancel" onSubmit={handleSubmit}>
        <Typography variant="body1">{t("Reason")}:</Typography>
        <FormControl variant="outlined" fullWidth>
          <Select name="reason" id="reason" defaultValue="NO_SHOW">
            {generateOptions()}
          </Select>
        </FormControl>
        <Typography variant="body1">{t("Notes")}</Typography>
        <textarea
          id="notes"
          name="notes"
          defaultValue={undefined}
          placeholder={t("Please enter notes")}
        />
      </form>
    </Container>
  );
};

export default SessionCancel;
